// extracted by mini-css-extract-plugin
export default {"lastUpdated":"lastUpdated---FZQav","lastUpdatedUser":"lastUpdatedUser---y8ahV"};